import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../lib/api';

// Shared Erfolge Tab component for all non-Vertriebler roles
const ErfolgeTab = ({ role }) => {
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${API}/user/team-leaderboard`).catch(() => ({ data: { leaderboard: [] } }));
        setLeaderboard(res.data?.leaderboard || []);
      } catch {}
      setLoading(false);
    };
    fetchData();
  }, []);

  const roleLabel = {
    vertriebsleiter: 'Vertriebsleiter',
    teamleiter: 'Teamleiter',
    admin: 'Administrator',
    backoffice: 'Innendienst',
  }[role] || role;

  if (loading) return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"></div>
      </div>
    </div>
  );

  return (
    <div className="container mx-auto px-4 py-8 space-y-6">
      {/* Role Header */}
      <div className="bg-white rounded-xl shadow-lg p-6 border-l-4 border-blue-500">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-lg font-bold text-gray-900">{roleLabel}</h2>
            <p className="text-sm text-gray-500 mt-1">Übersicht der Team-Erfolge und Rangliste</p>
          </div>
          <div className="rounded-xl p-3 bg-blue-50">
            <svg className="w-8 h-8 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M18.75 4.236c.982.143 1.954.317 2.916.52A6.003 6.003 0 0016.27 9.728M18.75 4.236V4.5c0 2.108-.966 3.99-2.48 5.228m0 0a6.003 6.003 0 01-2.48.713m4.96 0c-.298.07-.6.128-.908.172" />
            </svg>
          </div>
        </div>
      </div>

      {/* Rangliste */}
      <div className="bg-white rounded-xl shadow-lg p-6">
        <h2 className="text-base font-bold text-gray-900 mb-4">unfold's Rangliste</h2>
        {leaderboard.length === 0 ? (
          <div className="text-center py-10 text-gray-400">
            <p className="text-sm font-medium">Noch keine Daten vorhanden</p>
            <p className="text-xs mt-1">Sobald Vertriebler Schulungen abschließen, erscheint hier die Rangliste.</p>
          </div>
        ) : (
          <div className="space-y-2">
            {leaderboard.slice(0, 10).map((entry, idx) => (
              <div key={entry.id}
                className="flex items-center gap-3 rounded-xl px-4 py-3 bg-gray-50 hover:bg-gray-100 transition-colors"
                data-testid={`leaderboard-entry-${entry.id}`}>
                <span className="text-lg w-7 text-center flex-shrink-0 font-semibold text-gray-500">
                  {idx === 0 ? (entry.rank?.icon || '1.') : `${idx + 1}.`}
                </span>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-gray-800 truncate">{entry.name}</p>
                  <p className="text-xs text-gray-400">{entry.rank?.name} · {entry.badge_count} Badges · {entry.completed_modules} Module</p>
                </div>
                {entry.speed_badge && (
                  <span className="text-xs bg-amber-50 text-amber-700 border border-amber-100 px-2 py-0.5 rounded-full flex-shrink-0">
                    {entry.speed_badge}
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ErfolgeTab;
